import * as React from "react";
import Switch from "src/components";
import { WebsiteSystemItem } from "src/hooks/useWebsiteSystem";

export type WebsiteSystemSwitchesProps = {
  item: WebsiteSystemItem;
  canEdit: boolean;
  // True while this row's own toggle PATCH is in flight - disables the switch so
  // a second click cannot fire before the first one's response comes back.
  isSaving?: boolean;
  onToggle: (enabled: boolean) => void;
};

// One switch per row for every code. Which sites a PER_PRODUCT row shows on is
// the "เว็บที่แสดง" column's business (edited in the modal), not this switch's.
// Pure/presentational on purpose (no data hooks) so it can be unit-tested without
// a QueryClientProvider/RecoilRoot - see WebsiteSystemSwitches.test.tsx.
export const WebsiteSystemSwitches: React.FC<WebsiteSystemSwitchesProps> = ({
  item,
  canEdit,
  isSaving,
  onToggle,
}) => (
  <Switch checked={item.enabled} disabled={!canEdit || !!isSaving} onChange={(checked) => onToggle(checked)} />
);
